import React, { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where, updateDoc, doc, getDocs, getDoc, orderBy } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import { db } from '../../../firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEdit, faVolumeUp, faVolumeMute } from '@fortawesome/free-solid-svg-icons';
import CommandeDetailsModal from './CommandeDetailsModal';
import EditCommandeModal from './EditCommandeModal';
import ReactPaginate from 'react-paginate';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Howl } from 'howler';
import Spinner from 'react-bootstrap/Spinner';



const Commandes = () => {
    const [commandes, setCommandes] = useState([]);
    const [plats, setPlats] = useState([]);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedCommande, setSelectedCommande] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [playSound, setPlaySound] = useState(true);
    const [sound, setSound] = useState(null);
    const [showNotificationPopup, setShowNotificationPopup] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    // États pour les filtres
    const [dateService, setDateService] = useState('');
    const [statutPaiement, setStatutPaiement] = useState('');
    const [statutCommande, setStatutCommande] = useState('');
    const [previousPendingIds, setPreviousPendingIds] = useState([]);
    const [showEnableSoundPopup, setShowEnableSoundPopup] = useState(true);



    // États pour la pagination
    const [currentPage, setCurrentPage] = useState(0);
    const commandesPerPage = 10;

useEffect(() => {
    const commandesQuery = collection(db, 'commande');
    let q = query(commandesQuery);

    if (statutPaiement) q = query(q, where('statut_paiement', '==', statutPaiement));
    if (statutCommande) q = query(q, where('statut_commande', '==', statutCommande));
    if (dateService) q = query(q, where('date_service', '==', dateService));

    q = query(q, orderBy('id', 'desc'));

    const unsubscribe = onSnapshot(
        q,
        (snapshot) => {
            setLoading(true);

            const newCommandes = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
            }));

            newCommandes.sort((a, b) => parseInt(b.id) - parseInt(a.id));
            // Afficher la notification si une nouvelle commande arrive
                if (!isFirstLoad) {
                  
                    if (newCommandes.length > commandes.length) {
               
                        const latestCommande = newCommandes[0]; // Sélectionner la commande la plus récente
                        setSelectedCommande(latestCommande);
                        setShowNotificationPopup(true);
                        console.log("playSound:"+ playSound)
                        if (playSound) {
                            playNotificationSound();
                        }
                    }
                } else {
                    setIsFirstLoad(false);
                }

                setCommandes(newCommandes);
                setLoading(false);
        },
        (error) => {
            console.error('Erreur de récupération des commandes : ', error);
            setError('Impossible de charger les commandes. Veuillez réessayer.');
            setLoading(false);
        }
    );

    return () => unsubscribe();
}, [statutPaiement, statutCommande,isFirstLoad, dateService, playSound]);




    useEffect(() => {
        const fetchPlats = async () => {
            try {
                const platsCollection = collection(db, 'food-items');
                const platsSnapshot = await getDocs(platsCollection);
                const platsList = platsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setPlats(platsList);
            } catch (error) {
                console.error("Erreur de chargement des plats : ", error);
                setError("Impossible de charger les plats. Veuillez réessayer.");
            }
        };

        fetchPlats();
    }, []);

    const handleEnableSound = () => {
        setPlaySound(true); // autorise la lecture du son pour les notifications
        setShowEnableSoundPopup(false); // ferme le popup
    };

    const playNotificationSound = () => {
        if (!sound) {
            const newSound = new Howl({
                src: ['https://firebasestorage.googleapis.com/v0/b/chez-papy.firebasestorage.app/o/sonneries%2FCOMCell_Iphone%20sonnerie%20temps%20qui%20passe%20(ID%200449)_LS.wav?alt=media&token=7b5560ee-a21e-4207-a252-c1c0f060cef9'],
                loop: true,
                volume: 1.0,
            });
            setSound(newSound);
            newSound.play();
        } else {
            sound.play();
        }
    };

    const handleStopSound = () => {
        if (sound) {
            sound.pause();
            sound.seek(0); 
            setSound(null); 
        }
    };

    const handleShowDetails = (commande) => {
        setSelectedCommande(commande);
        setShowDetailsModal(true);
    };

    const handleShowEdit = (commande) => {
        setSelectedCommande(commande);
        setShowEditModal(true);
    };

    const handleClose = () => {
        setShowDetailsModal(false);
        setShowEditModal(false);
        setSelectedCommande(null);
    };

    const handleSave = async (updatedCommande) => {
        updatedCommande.plats = updatedCommande.plats.map(plat => ({
            id: plat.id,
            taille: plat.taille,
            total: plat.total,
            nom: plat.nom,
            prix: plat.prix,
            quantite: plat.quantite,
            instructions: plat.instructions,
            addons: plat.selectedAddons 
        }));

        
        try {
            const commandeRef = doc(db, 'commande', updatedCommande.id);
            await updateDoc(commandeRef, updatedCommande);

            setCommandes(prevCommandes =>
                prevCommandes.map(cmd =>
                    cmd.id === updatedCommande.id ? updatedCommande : cmd
                )
            );

            handleClose();
        } catch (error) {
            console.error("Erreur de mise à jour de la commande : ", error);
            setError("Impossible de mettre à jour la commande. Veuillez réessayer.");
        }

        
    };

    const updateCommandeStatus = async (commande,commandeId, newStatus, paymentIntentId) => {
          handleStopSound();
        setIsUpdating(true);
      
        try {
            const commandeRef = doc(db, 'commande', commandeId);
            await updateDoc(commandeRef, { statut_commande: newStatus });

            setCommandes(prevCommandes =>
                prevCommandes.map(cmd =>
                    cmd.id === commandeId ? { ...cmd, statut_commande: newStatus } : cmd
                )
            );
            if (newStatus === 'Accepté'){
                const emailContent = await getEmailContent('confirmationCommande');

                const emailResponse = await fetch('https://api-qdhov6jyia-uc.a.run.app/api/send-email', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        email: commande.email,
                        nom: commande.nom,
                        prenom: commande.prenom,
                        plats:commande.plats, 
                        total: commande.montant,
                        date_service: commande.date_service,
                        objet:emailContent.objet,
                        emailContent1:emailContent.texte,
                        emailContent2:emailContent.texte2
                    }),
                });
                if (emailResponse.ok) {
                    console.log('Email envoyé avec succès');
                } else {
                    console.error('Erreur lors de l\'envoi de l\'email');
                }
                
            }
            if (newStatus === 'Refusé' && paymentIntentId) {
                await handleRefund(paymentIntentId);

                await updateDoc(commandeRef, { statut_paiement: 'Remboursé' });

                setCommandes(prevCommandes =>
                    prevCommandes.map(cmd =>
                        cmd.id === commandeId ? { ...cmd, statut_commande: newStatus } : cmd
                    )
                );
            }
            setIsUpdating(false);
            setShowNotificationPopup(false);
           
        } catch (error) {
            console.error("Erreur lors de la mise à jour du statut de la commande : ", error);
            setError("Impossible de mettre à jour le statut de la commande. Veuillez réessayer.");
        }
    };


    const getEmailContent = async (id) => {
        try {
            const emailDoc = await getDoc(doc(db, 'email', id));
            if (emailDoc.exists()) {
                return emailDoc.data();
            } else {
                console.error('Document email non trouvé');
                return '';
            }
        } catch (error) {
            console.error('Erreur lors de la récupération de l\'email:', error);
            return '';
        }
    };


    const handleRefund = async (paymentIntentId) => {
        const emailAnn = await getEmailContent('annulationCommande');
        try {
            const response = await fetch('https://api-qdhov6jyia-uc.a.run.app/api/refund', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ paymentIntentId }),
            });

            const data = await response.json();

            if (data.success) {
                console.log('Remboursement réussi:', data.refund);
            } else {
                console.error('Erreur lors du remboursement:', data.error);
            }
        } catch (error) {
            console.error('Erreur de connexion au serveur:', error);
        }

        const emailResponse = await fetch('https://api-qdhov6jyia-uc.a.run.app/api/email-annulation', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                email: selectedCommande.email,
                nom: selectedCommande.nom,
                prenom: selectedCommande.prenom,
                objet:emailAnn.objet,
                emailContent:emailAnn.texte
            }),
        });
        
    };

    const indexOfLastCommande = (currentPage + 1) * commandesPerPage;
    const indexOfFirstCommande = indexOfLastCommande - commandesPerPage;

    const currentCommandes = commandes.slice(indexOfFirstCommande, indexOfLastCommande);
    const pageCount = Math.ceil(commandes.length / commandesPerPage);

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    if (loading) {
        return <div>Chargement...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="content-wrapper" className="d-flex flex-column ">
            <div id="content">
                <div className="container-fluid ">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h1 className="h3 text-gray-800">Commandes</h1>
                        
                    </div>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex align-items-center">
                            <h6 className="m-0 font-weight-bold title-2 mr-4">Toutes les commandes</h6>
                            {/* <select
                                id="statutPaiement"
                                className="form-control w-25 mr-2"
                                value={statutPaiement}
                                onChange={(e) => setStatutPaiement(e.target.value)}
                            >
                                <option value="">Tous les paiements</option>
                                <option value="Payé">Payé</option>
                                <option value="En cours">En cours</option>
                            </select>
                            <select
                                id="statutCommande"
                                className="form-control w-25 mr-2"
                                value={statutCommande}
                                onChange={(e) => setStatutCommande(e.target.value)}
                            >
                                <option value="">Toutes les commandes</option>
                                <option value="Accepté">Accepté</option>
                                <option value="En attente">En attente</option>
                                <option value="En cours">En cours</option>
                                <option value="Livré">Livré</option>
                                <option value="Annulé">Annulé</option>
                                <option value="Terminé">Terminé</option>
                            </select> */}
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" width="100%">
                                    <thead>
                                        <tr>
                                            <th>Commande</th>
                                            <th>Date de commande</th>
                                            <th>Date de récupération</th>
                                            <th>Statut de paiement</th>
                                            <th>Statut de la commande</th>
                                            <th>Montant</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentCommandes.map((commande) => (
                                            <tr key={commande.id}>
                                                <td>#{commande.id}</td>
                                                <td>{commande.date_commande}</td>
                                                <td>{commande.date_service}</td>
                                                <td>{commande.statut_paiement}</td>
                                                <td>{commande.statut_commande}</td>
                                                <td>{commande.montant}€</td>
                                                <td className='wth-100'>
                                                    <Link className="btn btn-info btn-circle btn-sm" to="#" onClick={() => handleShowDetails(commande)} aria-label={`View details for commande ${commande.id}`}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </Link>
                                                    <Link className="btn btn-primary btn-circle btn-sm ml-2" to="#" onClick={() => handleShowEdit(commande)} aria-label={`Edit commande ${commande.id}`}>
                                                        <FontAwesomeIcon icon={faEdit} />
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <ReactPaginate
                                    previousLabel={'Précédent'}
                                    nextLabel={'Suivant'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    previousClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextClassName={'page-item'}
                                    nextLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedCommande && showDetailsModal && (
                <CommandeDetailsModal
                    show={showDetailsModal}
                    handleClose={handleClose}
                    commande={selectedCommande}
                />
            )}

            {selectedCommande && showEditModal && (
                <EditCommandeModal
                    show={showEditModal}
                    handleClose={handleClose}
                    handleSave={handleSave}
                    commande={selectedCommande}
                    plats={plats}
                />
            )}

            {/* Popup pour activer le son à l'entrée */}
            <Modal show={showEnableSoundPopup} onHide={() => setShowEnableSoundPopup(false)} centered>
                <Modal.Header>
                    <Modal.Title>Activer les notifications sonores</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Pour recevoir les notifications sonores des nouvelles commandes, veuillez activer le son.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleEnableSound}>
                        Activer le son
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Notification Popup */}
            <Modal show={showNotificationPopup} onHide={() => {
        setShowNotificationPopup(false);
        handleStopSound(); // arrêter la sonnerie
    }} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Nouvelle commande</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedCommande ? (
                        <>
                            <p><strong>Commande ID :</strong> #{selectedCommande.id}</p>
                            <p><strong>Client :</strong> {selectedCommande.prenom} {selectedCommande.nom}</p>
                            <p><strong>Date de commande :</strong> {selectedCommande.date_commande}</p>
                            <p><strong>Date de récupération :</strong> {selectedCommande.date_service}</p>
                            <p><strong>Statut de paiement :</strong> {selectedCommande.statut_paiement}</p>
                            <p><strong>Montant :</strong> {selectedCommande.montant}€</p>
                            <p><strong>Articles :</strong></p>
                            <ul>
                                {selectedCommande.plats?.map((plat, index) => (
                                    <li key={index}>{plat.quantite} {plat.nom}</li>
                                ))}
                            </ul>
                        </>
                    ) : (
                        <p>Aucune commande sélectionnée.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button disabled={isUpdating} variant="success" onClick={() => { updateCommandeStatus(selectedCommande,selectedCommande.id, 'Accepté')
                         handleStopSound(); }}>
                    {isUpdating ? <span>Accepter <span className="spinner-border spinner-border-sm"></span></span> : <span>Accepter</span>}
                    </Button>
                    <Button disabled={isUpdating} variant="danger" onClick={() => {updateCommandeStatus(selectedCommande,selectedCommande.id, 'Refusé', selectedCommande.paymentIntentId)
                         handleStopSound(); } }>
                    {isUpdating ? <span>Refuser <span className="spinner-border spinner-border-sm"></span></span> : <span>Refuser</span>}
                    </Button>
                    
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Commandes;
